module.exports = __webpack_public_path__ + "static/img/fgbg2-2.243caec.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/2/fgbg2-2.png
// module id = 193
// module chunks = 0